




































import { Prop, Vue } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import { namespace } from 'vuex-class';
import { NAMESPACE } from '@/store/models/work/enterprise/cashRegisters';
import { GET_ITEMS, ITEMS_REQUEST } from '@/store';
import Component from 'vue-class-component';
import { Invoice } from '@/store/types/work/invoice';
import { CashRegisterModel } from '@/store/types/work/CashRegister';
import WorkHttp from '@/http/WorkHttp';

const CRStore = namespace(NAMESPACE);

@Component({
  components: { Dialog }
})
export default class AddCash extends Vue {
  @Prop() showDialog!: boolean;
  @Prop() outgoing!: boolean;
  @Prop() invoice!: Invoice;

  @CRStore.Action(ITEMS_REQUEST) CRRequest: any;
  @CRStore.Getter(GET_ITEMS) cash_registers!: CashRegisterModel[];

  protected params = {
    cash_register_id: null,
    comment: null,
    value: 0
  };

  public save () {
    (new WorkHttp(this.invoice.from_enterprise_id)).post({
      url: `/invoices/outgoing/${this.invoice.id}/add-obtained-cash`,
      data: this.params
    }).then(res => {
      this.$emit('save');
    }).catch(e => {
      alert('Сталась помилка під час заповнення форми. Перевірте коректність');
    });
  }

  created () {
    if (!this.cash_registers) {
      this.CRRequest();
    }
    this.params.value = this.debtSum;
  }

  get debtSum () {
    if (this.outgoing) {
      return this.invoice.cash - (this.invoice.obtained_cash || 0);
    }
    return this.invoice.cash - (this.invoice.transferred_cash || 0);
  }
}
